import { LoadAswMasterInfo } from '@lib/interfaces';
import { I18N_CONFIG } from './i18n.config';

/** 汎用データマスタキャッシュJSONデータのStoreに保存する際の共通キー */
const LISTDATA_COMMON_STORE_KEY = 'listData_pd_' as const;

/**
 * マスタキャッシュJSONデータのStoreに保存する際のキー
 */
export const MasterStoreKey = {
  /** プロパティマスタ_全リスト */
  PROPERTY: 'property',
  /** DxAPIエラーコード対応マスタ_全リスト */
  DXAPI_ERROR_CODE: 'dxapiErrorCode',
  /** iFlyエラーコード対応マスタ_エラーメッセージ */
  IFLY_ERROR_CODE_ERRORMESSAGE: 'IflyErrorCode_ErrorMessage',
  /** 運用確認メッセージ_全リスト */
  OPERATION_CONFIRM_LOG: 'operationConfirmLog',
  /** Tealium連携用画面名 */
  LISTDATA_PD_001: `${LISTDATA_COMMON_STORE_KEY}001`,
  /** 曜日リスト */
  LISTDATA_PD_016: `${LISTDATA_COMMON_STORE_KEY}016`,
  /** 曜日リスト */
  LISTDATA_PD_016_WEEK_FORMAT: `${LISTDATA_COMMON_STORE_KEY}016_week_format`,
  /** 月リスト */
  LISTDATA_PD_017: `${LISTDATA_COMMON_STORE_KEY}017`,
  CURRENCY_FORMAT_ALL: 'Currency_Format_All',
  OFFICE_ALL: 'Office_All',
  HOLIDAY_NATIONALHOLIDAYLISTFROMTODAY: `Holiday_NationalHolidayListFromToday`,
  DEPARTUREAIRPORT_ALL: 'DepartureAirport_All',
  DESTINATIONAIRPORT_ALL: 'DestinationAirport_All',
  REGION_ALL: 'Region_All',
  LANGCODECONVERT_ALL: 'LangCodeConvert_All',
  /** 空港別時差_空港コード */
  AIRPORT_TIMEDIFF: 'AirportTimeDiff_ByAirportCode',
  /** KMS追加start */
  LISTDATA_ALL: 'ListData_All',
  COUNTRY_ALL: 'Country_All',
  // 提携: AirCraftCabin_ACVandCabinからAirCraftCabin_I18nJoin_ACVandCabinを使用するように修正。
  // AIRCRAFT_CABIN_ACV_AND_CABIN: 'AirCraftCabin_ACVandCabin',
  AIRCRAFT_CABIN_I18NJOIN_ACV_AND_CABIN: 'AirCraftCabin_I18nJoin_ACVandCabin',
  /** 発着空港名 */
  M_AIRPORT_I18N: 'm_airport_i18n',
  /** 運航キャリアURL */
  // 提携: Airline_AirlineCodeからAirline_I18nJoin_ByAirlineCodeを使用するように修正。
  // AIRLINE_AIRLINECODE: 'Airline_AirlineCode',
  /** 運航キャリアURL */
  AIRLINE_I18NJOIN_BYAIRLINECODE: 'Airline_I18nJoin_ByAirlineCode',
  /** 運航キャリア名 */
  M_AIRLINE_I18N: 'm_airline_i18n',
  M_LIST_DATA_930: 'm_list_data_930',
  COUNTRY_WITHPOSCOUNTRYBYCONTACTTELNUMBERCOUNTRYFLG: 'Country_WithPosCountryByContactTelNumberCountryFlg',
  COUNTRY_WITHOUTPOSCOUNTRYANDJAPANBYCONTACTTELNUMBERCOUNTRYFLG:
    'Country_WithoutPosCountryAndJapanByContactTelNumberCountryFlg',
  COUNTRY_COUNTRYI18N_ALL: 'Country_CountryI18n_All',
  EQUIPMENT_BY_ACV: 'equipmentByAcv',
  /** KMS追加end */
} as const;

/**
 * ロードするマスタキャッシュ一覧
 */
export const LOAD_MASTER_LIST: LoadAswMasterInfo[] = [
  {
    key: MasterStoreKey.PROPERTY,
    fileName: 'Property_ForAkamaiCache',
  },
  {
    key: MasterStoreKey.DXAPI_ERROR_CODE,
    fileName: 'DxapiErrorCode_ForAkamaiCache',
  },
  {
    key: MasterStoreKey.OPERATION_CONFIRM_LOG,
    fileName: 'OperationConfirmLog',
  },
  {
    key: MasterStoreKey.LISTDATA_PD_016,
    fileName: 'ListLabelValue_pd_016',
  },
  {
    key: MasterStoreKey.LISTDATA_PD_016_WEEK_FORMAT,
    fileName: 'm_list_data_pd_016/M_list_data_pd_016',
    isCurrentLang: true,
  },
  {
    key: MasterStoreKey.LISTDATA_PD_017,
    fileName: 'ListLabelValue_pd_017',
  },
  {
    key: MasterStoreKey.CURRENCY_FORMAT_ALL,
    fileName: 'Currency_Format_All/Currency_Format',
    isCurrentLang: true,
  },
  {
    key: MasterStoreKey.OFFICE_ALL,
    fileName: 'Office_All',
  },
  {
    key: MasterStoreKey.HOLIDAY_NATIONALHOLIDAYLISTFROMTODAY,
    fileName: 'Holiday_NationalHolidayListFromToday',
  },
  {
    key: MasterStoreKey.DEPARTUREAIRPORT_ALL,
    fileName: 'DepartureAirport_All',
    isCurrentLang: true,
  },
  {
    key: MasterStoreKey.DESTINATIONAIRPORT_ALL,
    fileName: 'DestinationAirport_All',
    isCurrentLang: true,
  },
  {
    key: MasterStoreKey.REGION_ALL,
    fileName: 'Region_All',
    isCurrentLang: true,
  },
  {
    key: MasterStoreKey.LANGCODECONVERT_ALL,
    fileName: 'LangCodeConvert_All',
  },
  {
    key: MasterStoreKey.AIRPORT_TIMEDIFF,
    fileName: 'AirportTimeDiff_ByAirportCode',
    suffixKeys: ['_1', '_2'],
  },
  {
    key: MasterStoreKey.IFLY_ERROR_CODE_ERRORMESSAGE,
    fileName: 'IflyErrorCode_ErrorMessage',
  },
  /** KMS追加start */
  {
    key: MasterStoreKey.LISTDATA_ALL,
    fileName: 'ListData_All',
  },
  {
    key: MasterStoreKey.COUNTRY_ALL,
    fileName: 'Country_All',
  },
  // 提携: AirCraftCabin_ACVandCabinからAirCraftCabin_I18nJoin_ACVandCabinを使用するように修正。
  // {
  //   key: MasterStoreKey.AIRCRAFT_CABIN_ACV_AND_CABIN,
  //   fileName: 'AirCraftCabin_ACVandCabin',
  // },
  {
    key: MasterStoreKey.AIRCRAFT_CABIN_I18NJOIN_ACV_AND_CABIN,
    fileName: 'AirCraftCabin_I18nJoin_ACVandCabin',
    isCurrentLang: true,
  },
  {
    key: MasterStoreKey.M_AIRPORT_I18N,
    fileName: 'm_airport_i18n/M_airport_i18n',
    isCurrentLang: true,
  },
  {
    key: MasterStoreKey.M_AIRLINE_I18N,
    fileName: 'm_airline_i18n/M_airline_i18n',
    isCurrentLang: true,
  },
  // 提携: Airline_AirlineCodeからAirline_I18nJoin_ByAirlineCodeを使用するように修正。
  // {
  //   key: MasterStoreKey.AIRLINE_AIRLINECODE,
  //   fileName: 'Airline_AirlineCode',
  // },
  {
    key: MasterStoreKey.AIRLINE_I18NJOIN_BYAIRLINECODE,
    fileName: 'Airline_I18nJoin_ByAirlineCode',
    isCurrentLang: true,
  },
  {
    key: MasterStoreKey.M_LIST_DATA_930,
    fileName: 'm_list_data_930/M_list_data_930',
    isCurrentLang: true,
  },
  {
    key: MasterStoreKey.COUNTRY_WITHPOSCOUNTRYBYCONTACTTELNUMBERCOUNTRYFLG,
    fileName: 'Country_WithPosCountryByContactTelNumberCountryFlg',
    isCurrentLang: true,
  },
  {
    key: MasterStoreKey.COUNTRY_WITHOUTPOSCOUNTRYANDJAPANBYCONTACTTELNUMBERCOUNTRYFLG,
    fileName: 'Country_WithoutPosCountryAndJapanByContactTelNumberCountryFlg',
    isCurrentLang: true,
  },
  {
    key: MasterStoreKey.COUNTRY_COUNTRYI18N_ALL,
    fileName: 'Country_CountryI18n_All',
    isCurrentLang: true,
  },
  {
    key: MasterStoreKey.EQUIPMENT_BY_ACV,
    fileName: 'Equipment_ByAcv',
  },
  /** KMS追加end */
];

/**
 * マスタキャッシュJSONデータの各JSONキーPrefix
 */
export const MasterJsonKeyPrefix = {
  /** 静的文言 */
  STATIC: 'm_static_message-',
  /** エラー／ワーニング文言 */
  ERROR: 'm_error_message-',
  /** 動的文言 */
  DYNAMIC: 'm_dynamic_message-',
} as const;
